import { Button, Card, CardBody, Col, Container, Nav, NavItem, NavLink, Row, Spinner} from "reactstrap";
import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
import classNames from "classnames";
import "./styles.scss";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import FilterBar from "../../components/FilterBar/FilterBar";
import { useIsFirstRender } from "../../customHooks/useIsFirstRender";
import useLimitedRowSelection from "../../customHooks/useLimitedRowSelection";
import { MAX_ROW_SELECTION, PAGE_SIZE_OPTIONS } from "../../constants/pagination";
import ButtonCustom from "../../components/Buttons/ButtomCustom";
import useAlert from "../../customHooks/useAlert";
import { changePageSizeDocument, cleanMessageDocument, getDocumentDownloadHistory, getDocumentHistoryList, getDocumentPreview, getDocumentProducts, getDocumentSections, getDocumentSnippets, getDownloadDocument, getListaDocument, loadEmptyDocument, putDocumentBulkStatusUpdate } from "../../store/actions";
import CustomDatatable from "../../components/CustomDatatable/CustomDatatable";
import renderFormatedDate from "../../components/RenderCellsDatatable/renderFormatterDate";
import renderHeader from "../../components/RenderCellsDatatable/renderHeader";
import PillModal from "../../components/PillModal/PillModal";
import { Pill } from "../../components/Pill/Pill";
import StatusViewer from "../../components/StatusViewer/StatusViewer";
import HistoryModal from "../../components/HistoryModal/HistoryModal";
import moment from "moment";
import ActionList from "../../components/ActionList/ActionList";
import { useContextActions } from "../../customHooks/useContextActions";
import openPdfFromBase64 from "../../helpers/openPdfFromBase64";
import downloadBase64File from "../../helpers/downloadBase64File";
import { htmlForBulkModal } from "../../components/htmlForBulkModal/htmlForBulkModal";
import { BulkActionLimitInfo } from "../../components/BulkActionLimitInfo/BulkActionLimitInfo";

const statusBulk = {
		BulkSubmitter: "Draft",
		BulkReviewer: "Review",
		BulkPublisher: "Approved",
		BulkObsoleter: "Published",
	}

const BulkMain = ({
    userRoles,
    
    pageSizeDocument,
    getListDocumentRequest,
    listaDocument,
    loadingDocument,

    documentProducts,
    loadingProducts,
    errorProducts,
    documentSections,
    loadingSections,
    errorSections,
    documentSnippets,
    loadingSnippets,
    errorSnippets,

    getDocumentProducts,
    getDocumentSections,
    getDocumentSnippets,

    getDocumentPreviewRequest,
    getDownloadDocumentRequest,

    changePageSizeDocument,

    documentPreview,
    errorDocumentPreview,

    cleanMessageDocument,
    loadEmptyDocument,

    listaDocumentHistory,
    loadingDocumentHistory,
    errorLoadingDocumentHistory,
    
    getDocumentHistoryList,
    getDocumentDownloadHistoryRequest,

    documentDownloadHistory,
    errorDocumentDownloadHistory,

    documentDownload,
    errorDocumentDownload,

    putDocumentBulkStatusUpdateRequest,

    documentBulkStatusUpgrade,
    errorDocumentBulkStatusUpgrade,
}) => {
	
	const [activeTab, setActiveTab] = useState(null);
	const [objFilter, setObjFilter] = useState({
		status: null,
		createDateStart: null,
		updateDateStart: null,
		createDateEnd: null,
		updateDateEnd: null,
    regions: [],
    business: [],
    snippets: [],
		products: [],
		sections: [],
		createUsers: [],
		updateUsers: [],
		type: [],
		searchText: null,
	});
	const [paginationModel, setPaginationModel] = useState({
        pageSize: pageSizeDocument,
        page: 0,
  });
  const [currentPageHistory, setCurrentPageHistory] = useState(1);
  const [idCurrentDocumentHistory, setIdCurrentDocumentHistory] = useState(null);
	const { confirmBulkWorkflowChangeStatus, errorAlert, successAlert } = useAlert();
	
	const isFirstRender = useIsFirstRender();
	const { selectedRows, handleRowSelectionChange, selectedCount } = useLimitedRowSelection(MAX_ROW_SELECTION);
  
  const currentStatusWorkflow = activeTab ? [statusBulk[activeTab]] : [];
  const pageSizeHistory = 10;
  const totalPagesHistory = Math.ceil(
    (listaDocumentHistory?.totalRecords || 0) / pageSizeHistory
  );
  const pageSizeOptions = activeTab === "BulkReviewer" ? [5, 10, 20] : PAGE_SIZE_OPTIONS;
		
	const handleSaveSendToReview = () => {
		confirmBulkWorkflowChangeStatus(
      `<p style="margin-top: 24px;"><strong>${selectedCount} documents</strong> will be sent for review. Once submitted, they will require approval from a user with review permission before they can be published.</p>
      <p><strong>Do you want to continue?</strong></p>`,
      
    )
    .then((result) => {
      if (!result.isConfirmed) return;
      putDocumentBulkStatusUpdateRequest({
        body: Array.from(selectedRows.ids),
        type: "Draft"
      })
    })
  };
  const handleApprove = () => {
    confirmBulkWorkflowChangeStatus(
      `<p style="margin-top: 24px;"><strong>${selectedCount} documents</strong> will be approved. Once approved, they will be ready to be published and available in the Document Center</p>
      <p><strong>Do you want to continue?</strong></p>`,
      
    )
    .then((result) => {
      if (!result.isConfirmed) return;

      putDocumentBulkStatusUpdateRequest({
        body: Array.from(selectedRows.ids),
        type: "Approved"
      })
    });
  };
  const handleReject = () => {
    confirmBulkWorkflowChangeStatus(
      `<p style="margin-top: 24px;"><strong>${selectedCount} documents</strong> will be rejected and returned to draft status. Authors will need to resubmit them for review.</p>
      <p><strong>Do you want to continue?</strong></p>`,  
      
    )
    .then((result) => {
      if (!result.isConfirmed) return;

      putDocumentBulkStatusUpdateRequest({
        body: Array.from(selectedRows.ids),
        type: "Rejected"
      })
    });
	};
  const handlePublish = () => {
    confirmBulkWorkflowChangeStatus(
      `<p style="margin-top: 24px;"><strong>${selectedCount} documents</strong> will be published. Once published, they will become available in the Document Center and will replace any previous published versions.</p>
      <p><strong>Do you want to continue?</strong></p>`,
      
    )
    .then((result) => {
      if (!result.isConfirmed) return;

      putDocumentBulkStatusUpdateRequest({
        body: Array.from(selectedRows.ids),
        type: "Publish"
      })
    })
	};
  const handleObsolete = () => {
    confirmBulkWorkflowChangeStatus(
      `<p style="margin-top: 24px;"><strong>${selectedCount} documents</strong> will be marked as obsolete. Once marked, they will be removed from the Document Center but will remain accessible in the document history.</p>
      <p><strong>Do you want to continue?</strong></p>`,
      
    )
    .then((result) => {
      if (!result.isConfirmed) return;

      putDocumentBulkStatusUpdateRequest({
        body: Array.from(selectedRows.ids),
        type: "Obsolete"
      })
    })
	};

  const tabChange = (tab) => {
    setActiveTab(tab);
    handleRowSelectionChange([]);

    const newPageSize =
    tab === "BulkReviewer" && pageSizeDocument > 20 ? 20 : pageSizeDocument;

    setPaginationModel({
      page: 0,
      pageSize: newPageSize,
    });
  };
	const handlePageChange = (model) => {
    const { page, pageSize } = model;
    setPaginationModel({
      pageSize: pageSize,
      page: page,
    });
    changePageSizeDocument(pageSize);

    getListDocumentRequest({
      pageNumber: page + 1,
      pageSize: pageSize,
      status: objFilter.status,
      createDateStart: objFilter.createDateStart,
      updateDateStart: objFilter.updateDateStart,
      createDateEnd: objFilter.createDateEnd,
      updateDateEnd: objFilter.updateDateEnd,
      regions: objFilter.regions,
      business: objFilter.business,
      products: objFilter.products,
      sections: objFilter.sections,
      snippets: objFilter.snippets,
      createUsers: objFilter.createUsers,
      updateUsers: objFilter.updateUsers,
      statusWorkflow: currentStatusWorkflow,
      type: objFilter.type,
      searchText: objFilter.searchText,
    });
  };
  const handleSortChange = (model) => {
      console.log(model);
  };
  const fetchQuantityProducts = (documentId) => {
      getDocumentProducts({ documentId });
  };
  const fetchQuantitySections = (documentId) => {
      getDocumentSections({ documentId });
  };
  const fetchQuantitySnippets = (documentId) => {
      getDocumentSnippets({ documentId });
  };
  const handleDocumentPreview = (e, documentId) => {
    e.stopPropagation();
    getDocumentPreviewRequest({ documentId });
  };
  const handleDocumentDownloadPDF = (e, documentId) => {
    e.stopPropagation();
    getDownloadDocumentRequest({
      documentId: documentId,
      type: "pdf",
    });
  };
  const handleDocumentDownloadDOCX = (e, documentId) => {
    e.stopPropagation();
    getDownloadDocumentRequest({
      documentId: documentId,
      type: "docx",
    });
  };
  const fetchDocumentHistory = (documentId) => {
    getDocumentHistoryList({ documentId, page: 1 });
  };
  const handleDetailDocumentHistory = (item) => {
    window.open(`/document?idHistory=${item.idHistory}`, "_blank");
  };
  const handleDocumentDownloadHistoryDOCX = (documentId, type) => {
    getDocumentDownloadHistoryRequest({
      documentId: documentId,
      type: type,
    });
  };
  const handleDocumentDownloadHistoryPDF = (documentId, type) => {
    getDocumentDownloadHistoryRequest({
      documentId: documentId,
      type: type,
    });
  };
  const handlePageChangeHistory = (page) => {
    if (!idCurrentDocumentHistory) return;
    if (page < 1 || page > totalPagesHistory) return;
    setCurrentPageHistory(page);

    getDocumentHistoryList({
      documentId: idCurrentDocumentHistory,
      page,
    });
  };
  const refreshListData = () => {
    getListDocumentRequest({
      pageNumber: paginationModel.page + 1,
      pageSize: paginationModel.pageSize,
      status: objFilter.status,
      createDateStart: objFilter.createDateStart,
      updateDateStart: objFilter.updateDateStart,
      createDateEnd: objFilter.createDateEnd,
      updateDateEnd: objFilter.updateDateEnd,
      regions: objFilter.regions,
      business: objFilter.business,
      products: objFilter.products,
      sections: objFilter.sections,
      snippets: objFilter.snippets,
      createUsers: objFilter.createUsers,
      updateUsers: objFilter.updateUsers,
      statusWorkflow: currentStatusWorkflow,
      type: objFilter.type,
      searchText: objFilter.searchText,
    });
  };
  
  const actions = useContextActions({
    context: "document",
    screen: "list",
  });
  const columns = [
    {
      field: "createDate",
      headerName: "Creation date",
      flex: 1,
      sortable: false,
      renderCell: renderFormatedDate,
      renderHeader: renderHeader,
    },
    {
      field: "updateDate",
      headerName: "Update date",
      flex: 1,
      sortable: false,
      renderCell: renderFormatedDate,
      renderHeader: renderHeader,
    },
    {
      field: "regionName",
      headerName: "Region",
      flex: 1,
      sortable: false,
      renderHeader: renderHeader,
    },
    {
      field: "businessName",
      headerName: "Business",
      flex: 1,
      sortable: false,
      renderHeader: renderHeader,
    },
    {
      field: "title",
      headerName: "Document Title",
      flex: 2,
      sortable: false,
      renderHeader: renderHeader,
    },
    {
      field: "totalProducts",
      headerName: "Products",
      // flex: 1,
      sortable: false,
      renderHeader: renderHeader,
      renderCell: (params) => (
        <PillModal
          trigger={
            <Pill
              value={params.row.totalProducts}
              svg={
                <svg
                  width={18}
                  height={18}
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 640 640"
                >
                  <path
                    d="M272 32L368 32C385.7 32 400 46.3 400 64C400 81.7 385.7 96 368 96L272 96C254.3 96 240 81.7 240 64C240 46.3 254.3 32 272 32zM176 208C176 172.7 204.7 144 240 144L400 144C435.3 144 464 172.7 464 208C464 232.1 450.7 253.1 431 264C450.7 274.9 464 295.9 464 320C464 344.1 450.7 365.1 431 376C450.7 386.9 464 407.9 464 432C464 456.1 450.7 477.1 431 488C450.7 498.9 464 519.9 464 544C464 579.3 435.3 608 400 608L240 608C204.7 608 176 579.3 176 544C176 519.9 189.3 498.9 209 488C189.3 477.1 176 456.1 176 432C176 407.9 189.3 386.9 209 376C189.3 365.1 176 344.1 176 320C176 295.9 189.3 274.9 209 264C189.3 253.1 176 232.1 176 208z"
                    fill="white"
                  />
                </svg>
              }
            />
          }
          fetchQuantity={() => {
            fetchQuantityProducts(params.row.id);
          }}
          loading={loadingProducts}
          data={documentProducts}
          error={errorProducts}
          view="document" //View que estamos singular
          variant="Products" //Variante no plural
        />
      ),
    },
    {
      field: "totalSections",
      headerName: "Sections",
      // flex: 1,
      sortable: false,
      renderHeader: renderHeader,
      renderCell: (params) => (
        <PillModal
          trigger={
            <Pill
              value={params.row.totalSections}
              svg={
                <svg
                  width={18}
                  height={18}
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 640 640"
                >
                  <path
                    d="M465.4 192L431.1 144L209 144L174.7 192L465.4 192zM96 212.5C96 199.2 100.2 186.2 107.9 175.3L156.9 106.8C168.9 90 188.3 80 208.9 80L431 80C451.7 80 471.1 90 483.1 106.8L532 175.3C539.8 186.2 543.9 199.2 543.9 212.5L544 480C544 515.3 515.3 544 480 544L160 544C124.7 544 96 515.3 96 480L96 212.5z"
                    fill="white"
                  />
                </svg>
              }
            />
          }
          fetchQuantity={() => {
            fetchQuantitySections(params.row.id);
          }}
          loading={loadingSections}
          data={documentSections}
          error={errorSections}
          view="document" //View que estamos singular
          variant="Sections" //Variante no plural
        />
      ),
    },
    {
      field: "totalSnippets",
      headerName: "Snippets",
      // flex: 1,
      sortable: false,
      renderHeader: renderHeader,
      renderCell: (params) => (
        <PillModal
          trigger={
            <Pill
              value={params.row.totalSnippets}
              svg={
                <svg
                  width={18}
                  height={18}
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 640 640"
                >
                  <path
                    fill="white"
                    d="M296.5 69.2C311.4 62.3 328.6 62.3 343.5 69.2L562.1 170.2C570.6 174.1 576 182.6 576 192C576 201.4 570.6 209.9 562.1 213.8L343.5 314.8C328.6 321.7 311.4 321.7 296.5 314.8L77.9 213.8C69.4 209.8 64 201.3 64 192C64 182.7 69.4 174.1 77.9 170.2L296.5 69.2zM112.1 282.4L276.4 358.3C304.1 371.1 336 371.1 363.7 358.3L528 282.4L562.1 298.2C570.6 302.1 576 310.6 576 320C576 329.4 570.6 337.9 562.1 341.8L343.5 442.8C328.6 449.7 311.4 449.7 296.5 442.8L77.9 341.8C69.4 337.8 64 329.3 64 320C64 310.7 69.4 302.1 77.9 298.2L112 282.4zM77.9 426.2L112 410.4L276.3 486.3C304 499.1 335.9 499.1 363.6 486.3L527.9 410.4L562 426.2C570.5 430.1 575.9 438.6 575.9 448C575.9 457.4 570.5 465.9 562 469.8L343.4 570.8C328.5 577.7 311.3 577.7 296.4 570.8L77.9 469.8C69.4 465.8 64 457.3 64 448C64 438.7 69.4 430.1 77.9 426.2z"
                  />
                </svg>
              }
            />
          }
          fetchQuantity={() => {
            fetchQuantitySnippets(params.row.id);
          }}
          loading={loadingSnippets}
          data={documentSnippets}
          error={errorSnippets}
          view="document" //View que estamos singular
          variant="Snippets" //Variante no plural
        />
      ),
    },
    {
      field: "status",
      headerName: "Status",
      // flex: 1,
      sortable: false,
      renderHeader: renderHeader,
      renderCell: (params) => <StatusViewer status={params.value} />,
    },
    {
      field: "actions",
      headerName: "Actions",
      flex: 1,
      sortable: false,
      renderHeader: renderHeader,
      renderCell: (params) => (
        <ActionList
          id={params.row.id}
          status={params.row.status}
          onPreview={handleDocumentPreview}
          onDownloadPDF={(e) => handleDocumentDownloadPDF(e, params.row.id)}
          onDownloadDOCX={(e) => handleDocumentDownloadDOCX(e, params.row.id)}
          actions={actions}
          variant='bulk'
        />
      ),
    },
    {
      field: "id",
      headerName: "History",
      // flex: 1,
      sortable: false,
      renderHeader: renderHeader,
      renderCell: (params) => (
        <HistoryModal
          variant="documents"
          trigger={
            <Button color="" style={{ width: 50, height: 50 }}>
              <i className="fas fa-history"></i>
            </Button>
          }
          fetchHistory={() => {
            fetchDocumentHistory(params.value)
            setCurrentPageHistory(1);
            setIdCurrentDocumentHistory(params.value);
          }}
          loading={loadingDocumentHistory}
          data={listaDocumentHistory?.records}
          onDetail={handleDetailDocumentHistory}
          errorLoadingHistory={errorLoadingDocumentHistory}
          downloadHistoryPdf={(item) => handleDocumentDownloadHistoryPDF(item.idHistory, "pdf")}
          downloadHistoryDocx={(item) => handleDocumentDownloadHistoryDOCX(item.idHistory, "docx")}

          handlePageChange={handlePageChangeHistory}
          totalPages={totalPagesHistory}
          currentPage={currentPageHistory}

          columns={[
            {
              key: "updateDate",
              render: (item) =>
                moment(item.updateDate ?? item.createDate).format(
                  "DD MMM/YY hh:mm A",
                ),
            },
            {
              key: "status",
              render: (item) => {
                return <StatusViewer status={item.status} />;
              },
            },
            {
              key: "updateUser",
              render: (item) => item.updateUser ?? item.createUser,
            },
          ]}
        />
      ),
    },
  ];

	useEffect(() => {
		if (!activeTab) return;
		setPaginationModel((prev) => ({
			...prev,
			page: 0,
		}));
		getListDocumentRequest({
			pageNumber: 1,
			pageSize: paginationModel.pageSize,
			status: objFilter.status,
			createDateStart: objFilter.createDateStart,
			updateDateStart: objFilter.updateDateStart,
			createDateEnd: objFilter.createDateEnd,
			updateDateEnd: objFilter.updateDateEnd,
			regions: objFilter.regions,
			business: objFilter.business,
			products: objFilter.products,
			sections: objFilter.sections,
			snippets: objFilter.snippets,
			createUsers: objFilter.createUsers,
			updateUsers: objFilter.updateUsers,
			statusWorkflow: currentStatusWorkflow,
			type: objFilter.type,
			searchText: objFilter.searchText,
		});
	// eslint-disable-next-line
	}, [activeTab, objFilter]);
  useEffect(() => {
      if (documentPreview) {
        openPdfFromBase64(documentPreview.base64);
        return;
      }
  
      return () => {
        loadEmptyDocument();
      };
      // eslint-disable-next-line
  }, [documentPreview]);
  useEffect(() => {
    if (errorDocumentPreview) {
      errorAlert(
        errorDocumentPreview ? errorDocumentPreview : "Try again later!",
        {
          didClose: () => {
            cleanMessageDocument();
          },
        },
      );
    }
    // eslint-disable-next-line
  }, [errorDocumentPreview]);
  useEffect(() => {
      async function handleDownload() {
        if (documentDownload) {
          const { base64, fileName, extension } = documentDownload;
          const success = await downloadBase64File(base64, fileName, extension);
  
          if (success) {
            successAlert("Document downloaded successfully", {
              didClose: () => {
                cleanMessageDocument();
              },
            });
          }
  
          return;
        }
  
        if (errorDocumentDownload) {
          errorAlert(errorDocumentDownload || "Try again later!", {
            didClose: () => {
              cleanMessageDocument();
            },
          });
        }
      }
  
      handleDownload();
    
        // eslint-disable-next-line
  }, [documentDownload, errorDocumentDownload]);
  useEffect(() => {
      async function handleDownload() {
        if (documentDownloadHistory) {
          const { base64, fileName, extension } = documentDownloadHistory;
          const success = await downloadBase64File(base64, fileName, extension);
  
          if (success) {
            successAlert("Document downloaded successfully", {
              didClose: () => {
                cleanMessageDocument();
              },
            });
          }
  
          return;
        }
  
        if (errorDocumentDownloadHistory) {
          errorAlert(errorDocumentDownloadHistory || "Try again later!", {
            didClose: () => {
              cleanMessageDocument();
            },
          });
        }
      }
  
      handleDownload();
      // eslint-disable-next-line
  }, [documentDownloadHistory, errorDocumentDownloadHistory]);
  useEffect(() => {
    if (documentBulkStatusUpgrade !== null) {
      confirmBulkWorkflowChangeStatus(
        htmlForBulkModal(
          documentBulkStatusUpgrade.totalRecordsAffects,
          documentBulkStatusUpgrade.recordsError,),
        {
          icon: documentBulkStatusUpgrade.recordsError.length > 0 ? "warning" : "success",
          showCancelButton: false,
          confirmButtonText: "OK",
          iconColor: documentBulkStatusUpgrade.recordsError.length > 0 ? "#F56E50" : "#2CB57E",
                              
          didClose: () => {
            cleanMessageDocument();
            handleRowSelectionChange([]);
            refreshListData();
          },
        },
      );
    }

    if (errorDocumentBulkStatusUpgrade) {
      errorAlert(errorDocumentBulkStatusUpgrade || "Try again later!", {
        didClose: () => {
          cleanMessageDocument();
          handleRowSelectionChange([]);
        },
      });
    }
    // eslint-disable-next-line
  }, [documentBulkStatusUpgrade, errorDocumentBulkStatusUpgrade]);
	
	return (
		<div className="page-content">
			<Helmet><title>Bulk Actions</title></Helmet>

			<Container fluid>
				<Row>
					<Col lg={12}>
						<Card>
							<CardBody>
								
								<div>
									<h2 className="mb-4">DOCUMENTS - BULK ACTIONS</h2>
									<div>
										{activeTab === null && (<p style={{fontWeight: "bold"}}>Choose an action to continue</p>)}
										<Nav tabs className="bulk__nav">
												{userRoles !== null && ["BulkSubmitter"].some((role) => userRoles.includes(role)) ? (
													<NavItem>
														<NavLink
																style={{ cursor: "pointer" }}
																className={classNames({
																		active: activeTab === "BulkSubmitter",
                                    "bg--initial": activeTab === null,
																})}
																onClick={() => tabChange("BulkSubmitter")}
                                
														>
																Send for Review
														</NavLink>
													</NavItem>
												) : null}
												{userRoles !== null && ["BulkReviewer"].some((role) => userRoles.includes(role)) ? (
													<NavItem>
														<NavLink
																style={{ cursor: "pointer" }}
																className={classNames({
																		active: activeTab === "BulkReviewer",
                                    "bg--initial": activeTab === null,
																})}
																onClick={() => tabChange("BulkReviewer")}
                                
														>
																Review & Approve
														</NavLink>
													</NavItem>
												) : null}
												{userRoles !== null && ["BulkPublisher"].some((role) => userRoles.includes(role)) ? (
													<NavItem>
														<NavLink
																style={{ cursor: "pointer" }}
																className={classNames({
																		active: activeTab === "BulkPublisher",
                                    "bg--initial": activeTab === null,
																})}
																onClick={() => tabChange("BulkPublisher")}
                                
														>
																Publish
														</NavLink>
													</NavItem>
												)  : null}
												{userRoles !== null && ["BulkObsoleter"].some((role) => userRoles.includes(role)) ? (
													<NavItem>
														<NavLink
																style={{ cursor: "pointer" }}
																className={classNames({
																		active: activeTab === "BulkObsoleter",
                                    "bg--initial": activeTab === null,
																})}
																onClick={() => tabChange("BulkObsoleter")}
                                
														>
																Obsolete
														</NavLink>
													</NavItem>
												) : null}
										</Nav>

										{activeTab && (
											<div className="mt-4">
												<FilterBar
													objFilter={objFilter}
													setObjFilter={setObjFilter}
													isFirstRender={isFirstRender}
													placeholderSearch="Search by content"
													variant="bulk"
												/>
												<div className="d-flex justify-content-end mb-3" style={{gap: '16px'}}>
													{!loadingDocument && activeTab === "BulkSubmitter" && selectedCount > 0 && (
														<ButtonCustom 
															type="save_send"
															onClick={handleSaveSendToReview}
														/>
													)}
													{!loadingDocument && activeTab === "BulkReviewer" && selectedCount > 0 && (
														<div className="d-flex flex-column">
															<div className="d-flex justify-content-end gap-2 mb-3">
                                <ButtonCustom 
                                  type="reject"
                                  onClick={handleReject}
                                  disabled={selectedCount === 0 || selectedCount > 20}
                                />
                                <ButtonCustom
                                  type="approve"
                                  onClick={handleApprove}
                                  disabled={selectedCount === 0 || selectedCount > 20}
                                />
                              </div>
                              <BulkActionLimitInfo selectedCount={selectedRows.ids.size} max={20}/>
														</div>
													)}
													{!loadingDocument && activeTab === "BulkPublisher" && selectedCount > 0 && (
														<ButtonCustom
                              type="publish"
                              onClick={handlePublish}
                            />
													)}

													{!loadingDocument && activeTab === "BulkObsoleter" && selectedCount > 0 && (
														<ButtonCustom
															type="obsolete"
															onClick={handleObsolete}
														/>
													)}
												</div>
												{loadingDocument ? (
													<div
														className="d-flex align-items-center justify-content-center"
														style={{ height: 400, width: "100%" }}
													>
														<Spinner
															color="primary"
															style={{ height: "5rem", width: "5rem" }}
														/>
													</div>
												) : (
													<CustomDatatable
														columns={columns}
														rows={listaDocument?.records || []}
														pagination
														paginationMode="server"
														rowCount={listaDocument?.totalRecords || 0}
														paginationModel={paginationModel}
														onPaginationModelChange={handlePageChange}
														onSortModelChange={handleSortChange}
														onRowClick={false}
														pageSizeOptions={pageSizeOptions}
														disableColumnFilter
														disableColumnMenu
														checkboxSelection={true}
														rowSelectionModel={selectedRows}
														onRowSelectionModelChange={(model) =>
															handleRowSelectionChange(model, listaDocument.records)
														}
														isRowSelectableForStatus={true}
														isBulk={true}
													/>
												)}
											</div>
										)}
									</div>
								</div>
							</CardBody>
						</Card>
					</Col>
				</Row>
			</Container>
		</div>
	)
}

const mapStateToProps = ({
  RolesReducer: { userRoles },
  DocumentReducer: {
    pageSizeDocument,
    listaDocument,
    loadingDocument,

    documentProducts,
    loadingProducts,
    errorProducts,
    documentSections,
    loadingSections,
    errorSections,
    documentSnippets,
    loadingSnippets,
    errorSnippets,

    documentPreview,
    errorDocumentPreview,

    listaDocumentHistory,
    loadingDocumentHistory,
    errorLoadingDocumentHistory,
    totalPagesHistory,

    documentDownloadHistory,
    errorDocumentDownloadHistory,

    documentDownload,
    errorDocumentDownload,

    documentBulkStatusUpgrade,
    errorDocumentBulkStatusUpgrade,
    }
}) => ({
 	userRoles,

  pageSizeDocument,
	listaDocument,
	loadingDocument,

	documentProducts,
	loadingProducts,
	errorProducts,
	documentSections,
	loadingSections,
	errorSections,
	documentSnippets,
	loadingSnippets,
	errorSnippets,

  documentPreview,
  errorDocumentPreview,

  listaDocumentHistory,
  loadingDocumentHistory,
  errorLoadingDocumentHistory,

  documentDownloadHistory,
  errorDocumentDownloadHistory,

  documentDownload,
  errorDocumentDownload,

  documentBulkStatusUpgrade,
  errorDocumentBulkStatusUpgrade,
});

const mapDispatchToProps = {
	getListDocumentRequest: getListaDocument.request,
	
	getDocumentProducts: getDocumentProducts.request,
	getDocumentSnippets: getDocumentSnippets.request,
	getDocumentSections: getDocumentSections.request,

  getDocumentPreviewRequest: getDocumentPreview.request,
  getDownloadDocumentRequest: getDownloadDocument.request,

  getDocumentHistoryList: getDocumentHistoryList.request,
  getDocumentDownloadHistoryRequest: getDocumentDownloadHistory.request,

  putDocumentBulkStatusUpdateRequest: putDocumentBulkStatusUpdate.request,

	changePageSizeDocument,

  cleanMessageDocument,
  loadEmptyDocument,
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(BulkMain));